var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconExamPlanning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.22,
    height: 62.2,
    viewBox: "0 0 59.22 62.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.54,27.31V19.07h8.4v8.24Zm.84-.84H20.1V19.91H13.38Z",
    transform: "translate(-0.5 -0.5)",
    style: {
      fill: "#fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.44,18.57H12v9.24h9.4V18.57ZM13.88,26V20.41H19.6V26Z",
    transform: "translate(-0.5 -0.5)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.88,27.31V19.07h8.4v8.24Zm.84-.84h6.72V19.91H26.72Z",
    transform: "translate(-0.5 -0.5)",
    style: {
      fill: "#fff"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.78,18.57h-9.4v9.24h9.4V18.57ZM27.22,26V20.41h5.72V26Z",
    transform: "translate(-0.5 -0.5)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.28,27.31V19.07h8.4v8.24Zm.84-.84h6.72V19.91H40.12Z",
    transform: "translate(-0.5 -0.5)",
    style: {
      fill: "#fff"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.18,18.57h-9.4v9.24h9.4V18.57ZM40.62,26V20.41h5.72V26Z",
    transform: "translate(-0.5 -0.5)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.54,41.11V32.87h8.4v8.24Zm.84-.84H20.1V33.71H13.38Z",
    transform: "translate(-0.5 -0.5)",
    style: {
      fill: "#fff"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.44,32.37H12v9.24h9.4V32.37Zm-7.56,7.4V34.21H19.6v5.56Z",
    transform: "translate(-0.5 -0.5)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.88,41.11V32.87h8.4v8.24Zm.84-.84h6.72V33.71H26.72Z",
    transform: "translate(-0.5 -0.5)",
    style: {
      fill: "#fff"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.78,32.37h-9.4v9.24h9.4V32.37Zm-7.56,7.4V34.21h5.72v5.56Z",
    transform: "translate(-0.5 -0.5)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.28,41.11V32.87h8.4v8.24Zm.84-.84h6.72V33.71H40.12Z",
    transform: "translate(-0.5 -0.5)",
    style: {
      fill: "#fff"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.18,32.37h-9.4v9.24h9.4V32.37Zm-7.56,7.4V34.21h5.72v5.56Z",
    transform: "translate(-0.5 -0.5)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.54,54.91V46.67h8.4v8.24Zm.84-.84H20.1V47.51H13.38Z",
    transform: "translate(-0.5 -0.5)",
    style: {
      fill: "#fff"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.44,46.17H12v9.24h9.4V46.17Zm-7.56,7.4V48H19.6v5.56Z",
    transform: "translate(-0.5 -0.5)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.88,54.91V46.67h8.4v8.24Zm.84-.84h6.72V47.51H26.72Z",
    transform: "translate(-0.5 -0.5)",
    style: {
      fill: "#fff"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.78,46.17h-9.4v9.24h9.4V46.17Zm-7.56,7.4V48h5.72v5.56Z",
    transform: "translate(-0.5 -0.5)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1,62.2V4H8.52V1h.84V4h41.5V1h.84V4h7.52V62.2Zm.84-.84H58.38V13.18H1.84Zm0-49H58.38V4.82H51.7v3h-.84v-3H9.36v3H8.52v-3H1.84Z",
    transform: "translate(-0.5 -0.5)",
    style: {
      fill: "#fff"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2.5H50.36v3H9.86V.5H8v3H.5V62.7H59.72V3.48H52.2V.5ZM50.36,8.3H52.2v-3h5.68v6.52H2.34V5.32H8v3H9.86v-3h40.5v3Zm-48,52.56V13.68H57.88V60.86Z",
    transform: "translate(-0.5 -0.5)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExamPlanning);
export default __webpack_public_path__ + "static/media/icon-exam-planning.7b9584df.svg";
export { ForwardRef as ReactComponent };